<template>
    <table-client :columns="table.columns" :data="branches" :loading="loading" :options="tableOptions" id="dataTable"
                  theme="bootstrap4">
        <div class="table-actions" slot="actions" slot-scope="props">
            <menu-edit :id="props.row.id" :name="props.row.description" :options="menuOptions"
                       @remove="remove(props.row.id)"/>
        </div>
        <div class="table-code" slot="code" slot-scope="props">
            {{ props.row.code }}
        </div>
        <div class="table-description" slot="description" slot-scope="props">
            {{ props.row.description }}
        </div>
        <div class="table-country" slot="country" slot-scope="props">
            {{ getCountryName(props.row.country) }}
        </div>
        <div class="table-status" slot="status" slot-scope="props" style="font-size: 0.9em">
            <b-form-checkbox
                    :checked="checkboxChecked(props.row.status)"
                    :id="'checkbox_'+props.row.id"
                    :name="'checkbox_'+props.row.id"
                    switch
                    disabled>
            </b-form-checkbox>
        </div>
        <div class="table-loading text-center" slot="loading">
            <img alt="loading" height="51px" src="/images/loading.svg"/>
        </div>
    </table-client>
</template>

<script>
  import { API } from './../../api'
  import TableClient from './../../components/TableClient'
  import MenuEdit from './../../components/MenuEdit'
  import BFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox'

  export default {
    components: {
      'table-client': TableClient,
      'menu-edit': MenuEdit,
      BFormCheckbox
    },
    data: () => {
      return {
        loading: false,
        branches: [],
        table: {
          columns: ['actions', 'id', 'code', 'description', 'country', 'status']
        }
      }
    },
    mounted () {
      this.fetchData()
    },
    computed: {
      menuOptions: function () {
        let options = []

        if (this.$can('update', 'branches')) {
          options.push({
            type: 'edit',
            text: '',
            link: 'branches/edit/',
            icon: 'dot-circle',
            callback: '',
            type_action: 'link'
          })
        }
        if (this.$can('delete', 'branches')) {
          options.push({
            type: 'delete',
            text: '',
            link: '',
            icon: 'trash',
            type_action: 'button',
            callback_delete: 'remove'
          })
        }
        return options
      },
      tableOptions: function () {
        return {
          headings: {
            id: 'ID',
            code: this.$i18n.t('branches.code'),
            description: this.$i18n.t('branches.description'),
            country: this.$i18n.t('branches.country'),
            status: this.$i18n.t('branches.status'),
            actions: this.$i18n.t('global.table.actions')
          },
          sortable: ['id', 'code', 'description'],
          filterable: ['id', 'code', 'description']
        }
      }
    },
    methods: {
      checkboxChecked: function (status) {
        return status ? 'true' : 'false'
      },
      getCountryName: function (country) {
        if (!country) return '-'
        if (country.translations && country.translations.length > 0) {
          return country.translations[0].value
        }
        return country.iso
      },
      fetchData: function () {
        this.loading = true
        API.get('branches').then((result) => {
          this.loading = false
          if (result.data.success === true) {
            this.branches = result.data.data
          } else {
            this.$notify({
              group: 'main',
              type: 'error',
              title: 'Fetch Error',
              text: 'Error al obtener sedes'
            })
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            group: 'main',
            type: 'error',
            title: this.$i18n.t('branches.title'),
            text: 'Error de conexión'
          })
        })
      },
      remove (id) {
        API({
          method: 'POST',
          url: 'branches/validate/' + id
        }).then((result) => {
          if (confirm(result.data.message)) {
            API({
              method: 'DELETE',
              url: 'branches/' + id
            }).then((result) => {
              if (result.data.success === true) {
                this.fetchData()
              } else {
                this.$notify({
                  group: 'main',
                  type: 'error',
                  title: this.$i18n.t('branches.title'),
                  text: 'Error al eliminar sede'
                })
              }
            }).catch(() => {
              this.$notify({
                group: 'main',
                type: 'error',
                title: this.$i18n.t('branches.title'),
                text: 'Error de conexión'
              })
            })
          }
        })
      }
    }
  }
</script>

<style lang="stylus">
</style>
